import { useCallback } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { SellTreezService } from '@/services/sell-treez'
import { Record } from '@/models/record'
import { Param } from '@/models/params'

export const useSellTreezHistory = () => {
  const { sellTreezId } = useParams<Param>()
  const queryKey = ['sell-treez-history', sellTreezId]

  const getSellTreezHistory = useCallback(async () => {
    const response = await SellTreezService.getSellTreezHistory(sellTreezId as string)
    return response.data as Record[]
  }, [sellTreezId])

  const { data, isLoading, refetch } = useQuery({
    queryKey,
    queryFn: getSellTreezHistory,
    enabled: !!sellTreezId?.length,
    refetchInterval: 5000,
  })

  return { sellTreezHistory: data, isLoading, refetch }
}
